"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDashUsersForIds = getDashUsersForIds;
exports.getSlots = getSlots;
async function getDashUsersForIds(branchId, userIds) {
    const body = {
        "branchID": branchId,
        "userIDs": userIds,
    };
    const res = await fetch("/dashboard/summary/users_for_ids", {
        method: "POST",
        body: JSON.stringify(body),
        headers: {
            "Content-Type": "application/json",
        },
    });
    if (res.status !== 200) {
        const text = await res.text();
        throw new Error(text);
    }
    const out = await res.json();
    return out;
}
async function getSlots(options, cursor) {
    const params = new URLSearchParams();
    params.append("branchID", options.branchId.toString());
    params.append("fromGte", options.fromGte.toISOString());
    params.append("fromLt", options.fromLt.toISOString());
    if (options.roleIds?.length) {
        params.append("roleIDs", options.roleIds.join(","));
    }
    if (options.lockedOnly) {
        params.append("isLocked", options.lockedOnly.toString());
    }
    if (cursor) {
        params.append("cursor", cursor);
    }
    const res = await fetch(`/dashboard/summary/slots?${params.toString()}`, {
        method: "GET",
    });
    if (res.status !== 200) {
        const text = await res.text();
        throw new Error(text);
    }
    const out = await res.json();
    return out;
}
